import { render, staticRenderFns } from "./studentAttendanceStaff.vue?vue&type=template&id=68f0201c&scoped=true&"
import script from "./studentAttendanceStaff.vue?vue&type=script&lang=js&"
export * from "./studentAttendanceStaff.vue?vue&type=script&lang=js&"
import style0 from "./studentAttendanceStaff.vue?vue&type=style&index=0&id=68f0201c&lang=scss&scoped=true&"
import style1 from "./studentAttendanceStaff.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./studentAttendanceStaff.vue?vue&type=style&index=2&id=68f0201c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0201c",
  null
  
)

export default component.exports